import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { Box } from '../components/layout/Box'
import { Typography } from '../components/layout/Typography'
import Page from '../components/layout/Page'
import Container from '../components/layout/Container'
import { RouteType } from '../types/routes'
import { useUserLoggedInCheck } from '../hooks/useUserLoggedInCheck'
import { ApplicationState } from '../store'
import { Loading } from '../components/data/Loading'
import { SubmitButton } from '../styles/components/buttons'
import { userLogout } from '../store/user/actions'
import { getUrlWithSalonGuid } from '../utils/urlParams'
import { Anchor } from '../components/layout/Anchor'
import { ErrorMessage } from '../components/data/ErrorMessage'
import { Card } from '../components/layout/Card'
import { deleteUser } from '../api/profile'
import { useLoadSalonData } from '../hooks/useLoadSalonData'

const ProfilePage: React.FC = () => {
  useLoadSalonData({})
  useUserLoggedInCheck(RouteType.Login)

  const [isUserDeleteLoading, setIsUserDeleteLoading] = React.useState<boolean>(false)

  const dispatch = useDispatch()

  const history = useHistory()

  const { userData, loading: isUserLoading } = useSelector((state: ApplicationState) => state.user)

  if (!userData) return null

  const handleLogout = () => {
    dispatch(userLogout())
    history.push(getUrlWithSalonGuid(RouteType.Login))
  }

  const handleDeleteUserSubmit = async () => {
    setIsUserDeleteLoading(true)

    const response = await deleteUser()

    if (response !== null) {
      handleLogout()
    }

    setIsUserDeleteLoading(false)
  }

  const handleDeleteUserPress = async () => {
    const isConfirmed = window.confirm('Konto löschen - Bist du sicher?')

    if (isConfirmed) {
      handleDeleteUserSubmit()
    }
  }

  return (
    <Page>
      <Container>
        <Card>
          {(isUserLoading || isUserDeleteLoading) && <Loading />}

          <Box>
            <Typography variant="bold">Name: </Typography>
            <Typography variant="body1">{`${userData.vorname} ${userData.nachname}`}</Typography>
            <Typography variant="bold">Email: </Typography>
            <Typography variant="body1">{userData.email}</Typography>
            {userData.telefonnummer && (
              <>
                <Typography variant="bold">Phone: </Typography>
                <Typography variant="body1">{userData.telefonnummer}</Typography>
              </>
            )}
          </Box>

          <SubmitButton onClick={handleLogout}>Logout</SubmitButton>
        </Card>

        <Box flex flexDirection="row" centerHorizontal margin="2rem 0">
          <Anchor onClick={handleDeleteUserPress}>
            <ErrorMessage>Konto löschen</ErrorMessage>
          </Anchor>
        </Box>
      </Container>
    </Page>
  )
}

export default ProfilePage
